type FlagModule = {
    default: string;
};

const FLAG_LOADERS: Record<string, () => Promise<FlagModule>> = {
    "au-torres_strait_islands": () => import("./au-torres_strait_islands"),
    east_african_federation: () => import("./east_african_federation"),
    "us-confederate_battle": () => import("./us-confederate_battle"),
    "mt-civil_ensign": () => import("./mt-civil_ensign"),
    northern_cyprus: () => import("./northern_cyprus"),
    "aq-true_south": () => import("./aq-true_south"),
    "au-aboriginal": () => import("./au-aboriginal"),
    "by-historical": () => import("./by-historical"),
    "us-betsy_ross": () => import("./us-betsy_ross"),
    european_union: () => import("./european_union"),
    easter_island: () => import("./easter_island"),
    south_ossetia: () => import("./south_ossetia"),
    "tz-zanzibar": () => import("./tz-zanzibar"),
    soviet_union: () => import("./soviet_union"),
    transnistria: () => import("./transnistria"),
    "af-emirate": () => import("./af-emirate"),
    "es-variant": () => import("./es-variant"),
    somaliland: () => import("./somaliland"),
    yorubaland: () => import("./yorubaland"),
    occitania: () => import("./occitania"),
    malayali: () => import("./malayali"),
    "au-act": () => import("./au-act"),
    "au-nsw": () => import("./au-nsw"),
    "au-qld": () => import("./au-qld"),
    "au-tas": () => import("./au-tas"),
    "au-vic": () => import("./au-vic"),
    "fr-20r": () => import("./fr-20r"),
    "fr-bre": () => import("./fr-bre"),
    "gb-con": () => import("./gb-con"),
    "gb-eng": () => import("./gb-eng"),
    "gb-nir": () => import("./gb-nir"),
    "gb-ork": () => import("./gb-ork"),
    "gb-sct": () => import("./gb-sct"),
    "gb-wls": () => import("./gb-wls"),
    "mq-old": () => import("./mq-old"),
    "ru-dpr": () => import("./ru-dpr"),
    "ru-lpr": () => import("./ru-lpr"),
    "ua-bpr": () => import("./ua-bpr"),
    "ua-kpr": () => import("./ua-kpr"),
    artsakh: () => import("./artsakh"),
    guarani: () => import("./guarani"),
    quechua: () => import("./quechua"),
    sealand: () => import("./sealand"),
    wiphala: () => import("./wiphala"),
    "au-nt": () => import("./au-nt"),
    "au-sa": () => import("./au-sa"),
    "au-wa": () => import("./au-wa"),
    "bq-bo": () => import("./bq-bo"),
    "bq-sa": () => import("./bq-sa"),
    "bq-se": () => import("./bq-se"),
    "ca-bc": () => import("./ca-bc"),
    "ca-qc": () => import("./ca-qc"),
    "ch-gr": () => import("./ch-gr"),
    "cn-hk": () => import("./cn-hk"),
    "cn-xj": () => import("./cn-xj"),
    "cn-xz": () => import("./cn-xz"),
    "es-ar": () => import("./es-ar"),
    "es-ce": () => import("./es-ce"),
    "es-cn": () => import("./es-cn"),
    "es-ct": () => import("./es-ct"),
    "es-ga": () => import("./es-ga"),
    "es-ib": () => import("./es-ib"),
    "es-ml": () => import("./es-ml"),
    "es-pv": () => import("./es-pv"),
    "es-vc": () => import("./es-vc"),
    "et-af": () => import("./et-af"),
    "et-am": () => import("./et-am"),
    "et-be": () => import("./et-be"),
    "et-ga": () => import("./et-ga"),
    "et-ha": () => import("./et-ha"),
    "et-or": () => import("./et-or"),
    "et-si": () => import("./et-si"),
    "et-sn": () => import("./et-sn"),
    "et-so": () => import("./et-so"),
    "et-sw": () => import("./et-sw"),
    "et-ti": () => import("./et-ti"),
    "fr-cp": () => import("./fr-cp"),
    "ge-ab": () => import("./ge-ab"),
    "id-jb": () => import("./id-jb"),
    "id-jt": () => import("./id-jt"),
    "in-as": () => import("./in-as"),
    "in-gj": () => import("./in-gj"),
    "in-ka": () => import("./in-ka"),
    "in-mn": () => import("./in-mn"),
    "in-mz": () => import("./in-mz"),
    "in-or": () => import("./in-or"),
    "in-tg": () => import("./in-tg"),
    "in-tn": () => import("./in-tn"),
    "iq-kr": () => import("./iq-kr"),
    "it-21": () => import("./it-21"),
    "it-23": () => import("./it-23"),
    "it-25": () => import("./it-25"),
    "it-32": () => import("./it-32"),
    "it-34": () => import("./it-34"),
    "it-36": () => import("./it-36"),
    "it-42": () => import("./it-42"),
    "it-45": () => import("./it-45"),
    "it-52": () => import("./it-52"),
    "it-55": () => import("./it-55"),
    "it-57": () => import("./it-57"),
    "it-62": () => import("./it-62"),
    "it-65": () => import("./it-65"),
    "it-67": () => import("./it-67"),
    "it-72": () => import("./it-72"),
    "it-75": () => import("./it-75"),
    "it-77": () => import("./it-77"),
    "it-78": () => import("./it-78"),
    "it-82": () => import("./it-82"),
    "it-88": () => import("./it-88"),
    "nl-fr": () => import("./nl-fr"),
    "pk-jk": () => import("./pk-jk"),
    "pk-sd": () => import("./pk-sd"),
    "pt-20": () => import("./pt-20"),
    "pt-30": () => import("./pt-30"),
    "ru-ba": () => import("./ru-ba"),
    "ru-ce": () => import("./ru-ce"),
    "ru-cu": () => import("./ru-cu"),
    "ru-da": () => import("./ru-da"),
    "ru-ko": () => import("./ru-ko"),
    "ru-ta": () => import("./ru-ta"),
    "ru-ud": () => import("./ru-ud"),
    "sh-ac": () => import("./sh-ac"),
    "sh-hl": () => import("./sh-hl"),
    "sh-ta": () => import("./sh-ta"),
    "us-ak": () => import("./us-ak"),
    "us-al": () => import("./us-al"),
    "us-ar": () => import("./us-ar"),
    "us-as": () => import("./us-as"),
    "us-az": () => import("./us-az"),
    "us-ca": () => import("./us-ca"),
    "us-co": () => import("./us-co"),
    "us-dc": () => import("./us-dc"),
    "us-fl": () => import("./us-fl"),
    "us-ga": () => import("./us-ga"),
    "us-gu": () => import("./us-gu"),
    "us-hi": () => import("./us-hi"),
    "us-in": () => import("./us-in"),
    "us-md": () => import("./us-md"),
    "us-mn": () => import("./us-mn"),
    "us-mo": () => import("./us-mo"),
    "us-mp": () => import("./us-mp"),
    "us-ms": () => import("./us-ms"),
    "us-nc": () => import("./us-nc"),
    "us-nm": () => import("./us-nm"),
    "us-or": () => import("./us-or"),
    "us-pr": () => import("./us-pr"),
    "us-ri": () => import("./us-ri"),
    "us-sc": () => import("./us-sc"),
    "us-tn": () => import("./us-tn"),
    "us-tx": () => import("./us-tx"),
    "us-um": () => import("./us-um"),
    "us-vi": () => import("./us-vi"),
    "us-wa": () => import("./us-wa"),
    "us-wi": () => import("./us-wi"),
    "us-wy": () => import("./us-wy"),
    kanuri: () => import("./kanuri"),
    kikuyu: () => import("./kikuyu"),
    "ec-w": () => import("./ec-w"),
    hausa: () => import("./hausa"),
    hmong: () => import("./hmong"),
    kongo: () => import("./kongo"),
    maori: () => import("./maori"),
    otomi: () => import("./otomi"),
    sami: () => import("./sami"),
    ewe: () => import("./ewe"),
    ac: () => import("./ac"),
    ad: () => import("./ad"),
    ae: () => import("./ae"),
    af: () => import("./af"),
    ag: () => import("./ag"),
    ai: () => import("./ai"),
    al: () => import("./al"),
    am: () => import("./am"),
    an: () => import("./an"),
    ao: () => import("./ao"),
    aq: () => import("./aq"),
    ar: () => import("./ar"),
    as: () => import("./as"),
    at: () => import("./at"),
    au: () => import("./au"),
    aw: () => import("./aw"),
    ax: () => import("./ax"),
    az: () => import("./az"),
    ba: () => import("./ba"),
    bb: () => import("./bb"),
    bd: () => import("./bd"),
    be: () => import("./be"),
    bf: () => import("./bf"),
    bg: () => import("./bg"),
    bh: () => import("./bh"),
    bi: () => import("./bi"),
    bj: () => import("./bj"),
    bl: () => import("./bl"),
    bm: () => import("./bm"),
    bn: () => import("./bn"),
    bo: () => import("./bo"),
    bq: () => import("./bq"),
    br: () => import("./br"),
    bs: () => import("./bs"),
    bt: () => import("./bt"),
    bv: () => import("./bv"),
    bw: () => import("./bw"),
    by: () => import("./by"),
    bz: () => import("./bz"),
    ca: () => import("./ca"),
    cc: () => import("./cc"),
    cd: () => import("./cd"),
    cf: () => import("./cf"),
    cg: () => import("./cg"),
    ch: () => import("./ch"),
    ci: () => import("./ci"),
    ck: () => import("./ck"),
    cl: () => import("./cl"),
    cm: () => import("./cm"),
    cn: () => import("./cn"),
    co: () => import("./co"),
    cp: () => import("./cp"),
    cq: () => import("./cq"),
    cr: () => import("./cr"),
    cu: () => import("./cu"),
    cv: () => import("./cv"),
    cw: () => import("./cw"),
    cx: () => import("./cx"),
    cy: () => import("./cy"),
    cz: () => import("./cz"),
    de: () => import("./de"),
    dg: () => import("./dg"),
    dj: () => import("./dj"),
    dk: () => import("./dk"),
    dm: () => import("./dm"),
    do: () => import("./do"),
    dz: () => import("./dz"),
    ea: () => import("./ea"),
    ec: () => import("./ec"),
    ee: () => import("./ee"),
    eg: () => import("./eg"),
    eh: () => import("./eh"),
    er: () => import("./er"),
    es: () => import("./es"),
    et: () => import("./et"),
    eu: () => import("./eu"),
    fi: () => import("./fi"),
    fj: () => import("./fj"),
    fk: () => import("./fk"),
    fm: () => import("./fm"),
    fo: () => import("./fo"),
    fr: () => import("./fr"),
    fx: () => import("./fx"),
    ga: () => import("./ga"),
    gb: () => import("./gb"),
    gd: () => import("./gd"),
    ge: () => import("./ge"),
    gf: () => import("./gf"),
    gg: () => import("./gg"),
    gh: () => import("./gh"),
    gi: () => import("./gi"),
    gl: () => import("./gl"),
    gm: () => import("./gm"),
    gn: () => import("./gn"),
    gp: () => import("./gp"),
    gq: () => import("./gq"),
    gr: () => import("./gr"),
    gs: () => import("./gs"),
    gt: () => import("./gt"),
    gu: () => import("./gu"),
    gw: () => import("./gw"),
    gy: () => import("./gy"),
    hk: () => import("./hk"),
    hm: () => import("./hm"),
    hn: () => import("./hn"),
    hr: () => import("./hr"),
    ht: () => import("./ht"),
    hu: () => import("./hu"),
    ic: () => import("./ic"),
    id: () => import("./id"),
    ie: () => import("./ie"),
    im: () => import("./im"),
    in: () => import("./in"),
    io: () => import("./io"),
    iq: () => import("./iq"),
    ir: () => import("./ir"),
    is: () => import("./is"),
    it: () => import("./it"),
    je: () => import("./je"),
    jm: () => import("./jm"),
    jo: () => import("./jo"),
    jp: () => import("./jp"),
    ke: () => import("./ke"),
    kg: () => import("./kg"),
    kh: () => import("./kh"),
    ki: () => import("./ki"),
    km: () => import("./km"),
    kn: () => import("./kn"),
    kp: () => import("./kp"),
    kr: () => import("./kr"),
    kw: () => import("./kw"),
    ky: () => import("./ky"),
    kz: () => import("./kz"),
    la: () => import("./la"),
    lb: () => import("./lb"),
    lc: () => import("./lc"),
    li: () => import("./li"),
    lk: () => import("./lk"),
    lr: () => import("./lr"),
    ls: () => import("./ls"),
    lt: () => import("./lt"),
    lu: () => import("./lu"),
    lv: () => import("./lv"),
    ly: () => import("./ly"),
    ma: () => import("./ma"),
    mc: () => import("./mc"),
    md: () => import("./md"),
    me: () => import("./me"),
    mf: () => import("./mf"),
    mg: () => import("./mg"),
    mh: () => import("./mh"),
    mk: () => import("./mk"),
    ml: () => import("./ml"),
    mm: () => import("./mm"),
    mn: () => import("./mn"),
    mo: () => import("./mo"),
    mp: () => import("./mp"),
    mq: () => import("./mq"),
    mr: () => import("./mr"),
    ms: () => import("./ms"),
    mt: () => import("./mt"),
    mu: () => import("./mu"),
    mv: () => import("./mv"),
    mw: () => import("./mw"),
    mx: () => import("./mx"),
    my: () => import("./my"),
    mz: () => import("./mz"),
    na: () => import("./na"),
    nc: () => import("./nc"),
    ne: () => import("./ne"),
    nf: () => import("./nf"),
    ng: () => import("./ng"),
    ni: () => import("./ni"),
    nl: () => import("./nl"),
    no: () => import("./no"),
    np: () => import("./np"),
    nr: () => import("./nr"),
    nu: () => import("./nu"),
    nz: () => import("./nz"),
    om: () => import("./om"),
    pa: () => import("./pa"),
    pe: () => import("./pe"),
    pf: () => import("./pf"),
    pg: () => import("./pg"),
    ph: () => import("./ph"),
    pk: () => import("./pk"),
    pl: () => import("./pl"),
    pm: () => import("./pm"),
    pn: () => import("./pn"),
    pr: () => import("./pr"),
    ps: () => import("./ps"),
    pt: () => import("./pt"),
    pw: () => import("./pw"),
    py: () => import("./py"),
    qa: () => import("./qa"),
    re: () => import("./re"),
    ro: () => import("./ro"),
    rs: () => import("./rs"),
    ru: () => import("./ru"),
    rw: () => import("./rw"),
    sa: () => import("./sa"),
    sb: () => import("./sb"),
    sc: () => import("./sc"),
    sd: () => import("./sd"),
    se: () => import("./se"),
    sg: () => import("./sg"),
    sh: () => import("./sh"),
    si: () => import("./si"),
    sj: () => import("./sj"),
    sk: () => import("./sk"),
    sl: () => import("./sl"),
    sm: () => import("./sm"),
    sn: () => import("./sn"),
    so: () => import("./so"),
    sr: () => import("./sr"),
    ss: () => import("./ss"),
    st: () => import("./st"),
    su: () => import("./su"),
    sv: () => import("./sv"),
    sx: () => import("./sx"),
    sy: () => import("./sy"),
    sz: () => import("./sz"),
    ta: () => import("./ta"),
    tc: () => import("./tc"),
    td: () => import("./td"),
    tf: () => import("./tf"),
    tg: () => import("./tg"),
    th: () => import("./th"),
    tj: () => import("./tj"),
    tk: () => import("./tk"),
    tl: () => import("./tl"),
    tm: () => import("./tm"),
    tn: () => import("./tn"),
    to: () => import("./to"),
    tr: () => import("./tr"),
    tt: () => import("./tt"),
    tv: () => import("./tv"),
    tw: () => import("./tw"),
    tz: () => import("./tz"),
    ua: () => import("./ua"),
    ug: () => import("./ug"),
    uk: () => import("./uk"),
    um: () => import("./um"),
    un: () => import("./un"),
    us: () => import("./us"),
    uy: () => import("./uy"),
    uz: () => import("./uz"),
    va: () => import("./va"),
    vc: () => import("./vc"),
    ve: () => import("./ve"),
    vg: () => import("./vg"),
    vi: () => import("./vi"),
    vn: () => import("./vn"),
    vu: () => import("./vu"),
    wf: () => import("./wf"),
    ws: () => import("./ws"),
    xk: () => import("./xk"),
    xx: () => import("./xx"),
    ye: () => import("./ye"),
    yt: () => import("./yt"),
    yu: () => import("./yu"),
    za: () => import("./za"),
    zm: () => import("./zm"),
    zw: () => import("./zw")
};
export default FLAG_LOADERS;
